import { Theme } from '@mui/material'
import Styles from './CustomColors'
import { makeStyles } from 'tss-react/mui'
const { colors } = Styles

const useStyles = makeStyles()(
    ({ spacing, breakpoints: { up, down }, palette: { divider } }: Theme) => ({
        '@global': {
            '.grecaptcha-badge': {
                visibility: 'visible',
                opacity: '1',
                width: '70px !important',
                overflow: 'hidden !important',
                transition: 'all 0.3s ease !important',
                left: '4px !important',
                pointerEvents: 'auto',
            },
            '.grecaptcha-badge:hover': {
                width: '256px !important',
            },
        },
        root: {
            width: '100%',
            height: '100%',
            overflow: 'hidden',
        },
        error: {
            color: '#721c24',
            backgroundColor: '#f8d7da',
            borderColor: '#f5c6cb',
            padding: '2.75rem 1.25rem',
            border: '1px solid transparent',
            borderRadius: '.25rem',
        },
        logo: {
            height: spacing(4),
        },
        content: {
            flex: 1,
            padding: spacing(2, '10%'),
        },
        iconButton: {
            width: spacing(6),
            height: spacing(6),
            border: `1px solid ${divider}`,
            margin: spacing(0, 1),
        },
        field: {
            marginBottom: spacing(2),
        },
        icon: {
            height: 30,
            width: 30,
        },
        header: {
            marginTop: '1.8em',
            marginBottom: '1.4em',
        },
        avatar: {
            maxWidth: spacing(20),
            minWidth: spacing(15),
            height: 'auto',
            fontSize: 36,
            lineHeight: `${spacing(6)}`,
        },
        containerBox: {
            width: '100%',
            display: 'flex',
            height: '100vh',
        },
        left: {
            width: '70%',
            display: 'flex',
            background: 'linear-gradient(to right top, #203851, #1e3853, #1b3855, #193757, #163759, #113b5d, #094061, #004465, #004e69, #00586a, #006168, #126964);',
            flexDirection: 'column',
            position: 'relative',
            [down('md')]: {
                display: 'none',
            },
        },
        leftContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            // alignItems : 'center',
            height: '90vh',
            '@media (min-width: 1270px) and (max-width: 1500px)': {
                padding: '2em',
            },
            padding: '5em 5em 0em 5em',
        },
        listContainerItem: {
            '@media (min-width: 1270px) and (max-width: 1500px)': {
                fontSize: '12px',
            },
            fontSize: '16px',
        },
        right: {
            width: '40%',
            overflow: "auto",
            [down('md')]: {
                width: '100%',
            },
        },
        heading1: {
            fontWeight: 600,
            fontSize: '28px',
            color: colors.primary,
            // color : '#F4DCC7',
            [down('lg')]: {
                fontSize: '22px',
            },
        },
        subHeading1: {
            fontSize: '20px',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '0.5px',
            '@media (min-width: 1270px) and (max-width: 1500px)': {
                fontSize: '16px',
            },
        },
        heading2: {
            color: '#093444',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '150%',
            letterSpacing: '-0.48px',
            [down('lg')]: {
                fontSize: '20px',
            },
            '@media (min-width: 1270px) and (max-width: 1500px)': {
                fontSize: '16px',
            },
        },
        lightHeading3: {
            // color: 'rgba(9, 52, 68, 0.91)',
            color : 'white',
            fontSize: '16px',
            fontWeight: 400,
            letterSpacing: '-0.32px',
            [down('lg')]: {
                fontSize: '13px',
            },
        },
        heading3: {
            fontWeight: 600,
            lineHeight: '42px',
            fontSize: '20px',
            color: colors.primary,
        },
        heading4: {
            fontWeight: 600,
            fontSize: '16px',
            color: colors.primary,
        },
        listItem: {
            padding: '0 5px',
        },
        listContainer: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: '1.5em',
            paddingLeft: '1.5em',
            gap: '2px',
        },
        reviewsContainer: {
            backgroundColor: colors.primary,
            background: '#baac80',
            display: 'flex',
            justifyContent: 'space-around',
            height: '6%',
            padding: '1.5em 3em',
            width: '100%',
            alignItems: 'center',
            position: 'absolute',
            bottom: 0,
            left: 0,
        },
        flexJustifyCenter: {
            display: 'flex',
            justifyContent: 'center',
        },
        flexJustifyAlignCenter: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        mobileAppsContainer: {
            display: 'flex',
            gap: '.8em',
            alignItems: 'center',
            justifyContent : 'center',
            padding: '.7em',
            borderRadius: '2px',
            border: '1px solid rgb(12, 45, 80)',
            background: 'rgb(12, 45, 80)',
            width : 'fit-content',
        },
        line: {
            width: '.8px',
            height: '40px',
            backgroundColor: 'white',
        },
        submitButton: {
            color: 'white',
            backgroundColor: colors.primary,
            fontWeight: 600,
            letterSpacing: '.5px',
        },
        switchContainer: {
            borderRadius: '43px',
            border: `1px ${colors.darkBlue}`,
            background: colors.babyBlue,
            width: 'fit-content',
            display: 'flex',
            gap: '0.5em',
            padding: '.5em 2em',
        },
        learnMoreButton: {
            padding: '.5em 2em',
            marginTop: '2em',
            marginBottom: '2em',
            color: '#007AFF',
            textAlign: 'center',
            border: `1px ${colors.darkBlue}`,
            background: colors.babyBlue,
            borderRadius: '20px',
            [down('lg')]: {
                padding: '0.5em 1.3em',
                fontSize: '12px',
            },
            '@media (min-width: 1270px) and (max-width: 1500px)': {
                fontSize: '14px',
                marginTop: '.5em',
                marginBottom: '.5em',
            },
        },
        reviewsBox: {
            display: 'flex',
        },
        avatarBox: {
            height: '25vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '0.8em',
        },
        carouselBox: {
            textAlign: 'center',
            // display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        },
        successContainer: {
            padding: '3em',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: colors.lightPurple,
            [down('md')]: {
                padding: '4em',
            },
            [down('sm')]: {
                padding: '2em',
            },
            height: '100vh',
        },
        successBox: {
            background: 'white',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            width: '30%',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            flexDirection: 'column',
            padding: '1em 4em',
            [down('md')]: {
                width: '70%',
            },
            [down('sm')]: {
                width: '100%',
            },
        },
        link: {
            fontWeight: 600,
        },
    })
)

export default useStyles
